import { BoardTemplateLocalListItemType } from '../types';

export const getIsLocalTemplate = (
  templateId: BoardTemplateLocalListItemType['id'],
) => typeof templateId === 'string';
